// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1vNdW","header":"MergedInvoice_header__1Dj2I"};